<template>
  <div class="mobile-header">
    <div class="icon-container" style="margin: 14px 0 4px 6px">
      <font-awesome-icon icon="arrow-left" size="lg" @click="goBack" />
    </div>
    <div class="background" />
    <MobileMenu is-mobile />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import MobileMenu from '@/components/public/mobile/MobileMenu.vue'
import Teleport from 'vue2-teleport' // TODO: Remove this import and component when migrating to vue3

const components = {
  Teleport,
  MobileMenu,
}

@Component({ components })
export default class MobileHeader extends Vue {
  menuOpen = false

  get logoImg() {
    const logo = this.$typedStore.primary.app.config.appConfig.logo
    return logo
      ? logo.img
        ? this.$typedStore.primary.entities.images.image(logo.img)
        : logo
      : null
  }

  get disableMobileHamburger() {
    return this.$typedStore.primary.app.config.appConfig.disableMobileHamburger
  }

  goBack() {
    window.history.back()
  }
}
</script>

<style lang="scss" scoped>
.mobile-header {
  position: sticky;
  top: 0;
  left: 0;
  padding-left: env(safe-area-inset-left);
  color: var(--story-foreground);
  width: 100%;
  display: flex;
  height: 44px;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  .background {
    background: linear-gradient(
      to bottom,
      var(--story-background) 0%,
      var(--story-background) 90%,
      transparent 100%
    );
    width: 100%;
    height: 44px;
    z-index: -1;
    position: absolute;
  }
  .icon-container {
    width: 38px;
    height: 38px;
    padding: 2px;
  }
}
.mobile-menu-container {
  z-index: 4;
  position: fixed;
  top: 0;
  height: calc(100% - 44px);
  width: 100%;
  margin-top: 44px;
  transition: transform 0.2s;
  backdrop-filter: blur(1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  @media (orientation: landscape) {
    left: 0;
    &.slide-enter,
    &.slide-leave-to {
      transform: translateX(-100%);
    }
  }
  @media (orientation: portrait) {
    right: 0;
    &.slide-enter,
    &.slide-leave-to {
      transform: translateX(100%);
    }
  }
  &.slide-enter,
  &.slide-leave-to {
    .menu-overlay {
      opacity: 0;
    }
  }
  .menu-overlay {
    z-index: -1;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    transition: opacity 0.8s;
    background: rgba(1, 1, 1, 0.3);
  }
}
</style>
